import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListCustomFields from "../../../../components/@custom_fields/ListCustomFields";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomFieldsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListCustomFields
                routeType={routeType}
            />
        </SettingFrame>
    )

}       